import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/rally";

export const getAllRallies = async (params = {}) => {
  return jeepRallyApi.get(baseUrl, { params });
};

export const getActiveRally = async () => {
  return jeepRallyApi.get(`${baseUrl}/active`);
};

export const getRallyById = async (id) => {
  return jeepRallyApi.get(`${baseUrl}/${id}`);
};

export const createRally = async (rally) => {
  return jeepRallyApi.post(baseUrl, rally);
};

export const updateRally = async (id, rally) => {
  return jeepRallyApi.put(`${baseUrl}/${id}`, rally);
};

export const deleteRally = async (id) => {
  return jeepRallyApi.delete(`${baseUrl}/${id}`);
};

export const getRallyStages = async (eventId) => {
  return jeepRallyApi.get(`${baseUrl}/${eventId}/stages`);
};

export const getRallyCompetitors = async (eventId, params = {}) => {
  return jeepRallyApi.get(`${baseUrl}/${eventId}/competitors`, { params });
};

export const updateRallyBanner = async (id, formData) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}/banner`, formData);
};

export const updateRallyThumbnail = async (id, formData) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}/thumbnail`, formData);
};

/** @deprecated Prefer sending `prices` on create/update rally payload. */
export const createRallyPricing = (eventId, payload) => {
  return jeepRallyApi.post(`${baseUrl}/${eventId}/pricing`, payload);
};

/** @deprecated Prefer sending `prices` on create/update rally payload. */
export const createRallyPricings = (eventId, prices = []) => {
  return Promise.all(
    prices.map((payload) => createRallyPricing(eventId, payload))
  );
};
